export default __webpack_public_path__ + "static/media/Imagen_default_video.b02ba90d.png";